// extracted by mini-css-extract-plugin
module.exports = {"Logo":"Logo_Logo__3_5qz","LogoImage":"Logo_LogoImage__3yylL","NightLogoImage":"Logo_NightLogoImage__q-WWn"};